import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogTitle, IconButton, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CloseOutlined from '@mui/icons-material/CloseOutlined';
import CabasEstimatePicker from './CabasEstimatePicker';

/** "Hae CABAS-laskelma" on a work order: import an estimate into this work order. */
export default function CabasEstimateDialog({ open, onClose, maintenance, onImported, onOpenMaintenance }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" fullScreen={fullScreen} data-testid="cabas-dialog">
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', pr: 1 }}>
        {t('cabas.dialogTitle')}
        <IconButton onClick={onClose} sx={{ ml: 'auto' }} aria-label={t('Close')}>
          <CloseOutlined />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {open && (
          <CabasEstimatePicker
            maintenance={maintenance}
            onImported={onImported}
            onOpenMaintenance={onOpenMaintenance}
            onCancel={onClose}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
